// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__1gZR8","bg":"Card_bg__9RiwZ","wrap":"Card_wrap__Jj2GX","title":"Card_title__UAwuT","text":"Card_text__vEEPF"};